const moduleName = 'tabs';

export function tabs () {
    document.querySelectorAll('input.js-tabs-input').forEach((input) => {
        input.addEventListener('change', function (){
            const wrap = this.closest('.tabs-wrap');
            const content = wrap.querySelector(`#${this.dataset.depId}`);
            if(this.checked){
                wrap.querySelector('.box._visible').classList.remove('_visible');
                content.classList.add('_visible');
            }
        });
    });
}
